export default __webpack_public_path__ + "static/media/home_news_inactive.1245823c.svg";